export function initIrnby() {
  document.documentElement.classList.add('irnby')
}
